export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : window.location.hostname.includes("localhost")
  ? "http://localhost:3000/api/"
  : "https://" + window.location.hostname + "/api/";
